import React, { useEffect, useState } from "react";
import styled from "styled-components";
import clsx from "clsx";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  // background: black;
  font-size: 2em;
  width: 43px;
  height: 43px;
  border-radius: 100%;
  opacity: 0;
  transition: transform 100ms ease, width 200ms, height 200ms;

  pointer-events: none;
  will-change: transform;
  // opacity: 0;
  svg {
    width: 100%;
    height: 100%;
    transition: transform 200ms ease;
    transform: rotate(0deg);
  }
  &.is-anchor-or-button {
    // opacity: 1;
    // width: 60px;
    // height: 60px;
    // background: transparent;
    // border: 1px solid;
    svg {
      transform: rotate(45deg) scale(0.4);
      // opacity: 0;
    }
  }
  &.is-mousedown {
    // opacity: 1;
    // width: 16px;
    // height: 16px;
    // background: transparent;
    // border: 1px solid;
    svg {
      transform: rotate(-45deg) scale(0.9);
    }
  }

  @media all and (max-width: 991px) {
    display: none;
  }
`;

//https://codepen.io/Starglider/pen/LYEELVy?editors=0010
const CursorLogo = () => {
  // const inertia = 0.3;
  const [css, setCss] = useState({ x: 0, y: 0, opacity: 0, rotate: 0 });
  const [isAnchorOrButton, setIsAnchorOrButton] = useState(false);
  const [isMouseDown, setIsMouseDown] = useState(false);

  useEffect(() => {
    document.addEventListener("mousemove", _onMouseMove);
    document.addEventListener("mousedown", _onMouseDown);
    document.addEventListener("mouseup", _onMouseUp);

    return () => {
      document.removeEventListener("mousemove", _onMouseMove);
      document.removeEventListener("mousedown", _onMouseDown);
      document.removeEventListener("mouseup", _onMouseUp);
    };
  }, []);

  const _onMouseMove = e => {
    const __isAnchorOrButton = _getIsAnchorOrButton(e.target);
    setIsAnchorOrButton(__isAnchorOrButton);

    let offset = 22.5;

    setCss(css => ({
      ...css,
      x: e.clientX - offset + 2,
      y: e.clientY - offset + 2.5,
      opacity: 0.5
    }));
  };

  // const _update = e => {};

  const _onMouseDown = () => setIsMouseDown(true);
  const _onMouseUp = () => setIsMouseDown(false);

  const _getIsAnchorOrButton = target => {
    // console.log(target.classList.contains("button"));
    return (
      target.tagName.toLowerCase() === "a" ||
      target.tagName.toLowerCase() === "button" ||
      target.classList.contains("button") ||
      target.classList.contains("pointer")
    );
  };
  // console.log(css)
  return (
    <Wrapper
      className={clsx(
        "cursor",
        isAnchorOrButton ? "is-anchor-or-button" : "",
        isMouseDown ? "is-mousedown" : ""
      )}
      style={{
        transform: `translate(${css.x}px, ${css.y}px) rotate(${css.rotate}deg)`,
        opacity: css.opacity
      }}>
      <svg
        id='d7569c62-effd-4682-a065-358a4b3dcc47'
        data-name='Calque 1'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 27 27.09'>
        <title>asphalt-chronicles-logo-obturator</title>
        <path d='M27,12.63v0A13.53,13.53,0,0,0,12.59,0l-.2,0A13.29,13.29,0,0,0,6.45,2,14,14,0,0,0,2.12,6.26,13.55,13.55,0,0,0,0,14.47v0A13.5,13.5,0,0,0,8.29,26a13.27,13.27,0,0,0,5.18,1.05c.31,0,.63,0,.94,0a13.24,13.24,0,0,0,5.95-1.85A13.62,13.62,0,0,0,27,12.63ZM13.22.81a.33.33,0,0,1,.29-.16,12.71,12.71,0,0,1,9.06,3.78.36.36,0,0,1,.09.36l-2.73,7.1a.31.31,0,0,1-.29.22.29.29,0,0,1-.32-.18L13.22,1.15a.3.3,0,0,1,0-.34Zm5.41,12.74A5.13,5.13,0,1,1,13.5,8.41,5.13,5.13,0,0,1,18.63,13.54ZM3.26,5.74A13.13,13.13,0,0,1,6.76,2.57,12.75,12.75,0,0,1,12,.75h0a.32.32,0,0,1,.29.18L16,7.45a.32.32,0,0,1,0,.12.33.33,0,0,1,0,.13.32.32,0,0,1-.06.12.32.32,0,0,1-.1.08.37.37,0,0,1-.23,0L3.46,6.31a.35.35,0,0,1-.29-.38.67.67,0,0,0,.09-.18ZM1,16.6A.35.35,0,0,1,1,16.45a12,12,0,0,1-.29-2v0A12.76,12.76,0,0,1,2.43,7a.35.35,0,0,1,.29-.18h0l7.43,1a.35.35,0,0,1,.29.38.26.26,0,0,1,0,.11.27.27,0,0,1-.08.09L1.55,16.62a.52.52,0,0,1-.36.07A.35.35,0,0,1,1,16.6ZM8,24.8a.3.3,0,0,1-.11.13h0a.4.4,0,0,1-.36,0,12.81,12.81,0,0,1-6.1-7,.31.31,0,0,1,.09-.36l5.18-4.82a.32.32,0,0,1,.11-.07l.13,0,.13,0a.32.32,0,0,1,.1.08.4.4,0,0,1,.09.2L8,24.63A.3.3,0,0,1,8,24.8Zm11.34.12a.34.34,0,0,1-.05.12c-.09,0-.14.09-.18.11h0a12.82,12.82,0,0,1-10.14.43.31.31,0,0,1-.22-.29l-.49-7.56a.36.36,0,0,1,.18-.31.42.42,0,0,1,.18,0,.36.36,0,0,1,.2.07l10.38,7.13a.34.34,0,0,1,.14.35ZM26,16.45h0a13,13,0,0,1-5.61,8,.39.39,0,0,1-.38,0l-6.26-4.3a.32.32,0,0,1-.12-.15.32.32,0,0,1,0-.19.31.31,0,0,1,.25-.27L25.63,16l.09,0a.35.35,0,0,1,.34.34A.17.17,0,0,0,26,16.45Zm.25-1.51a.37.37,0,0,1-.25.29l-6.89,2a.36.36,0,0,1-.43-.23.38.38,0,0,1,0-.22L23,5.68a.29.29,0,0,1,.27-.2h0a.32.32,0,0,1,.27.14,12.83,12.83,0,0,1,2.71,7.06h0A12.49,12.49,0,0,1,26.28,14.95Z' />
      </svg>
    </Wrapper>
  );
};

export default CursorLogo;
